<script setup>
import { computed } from "vue";
import ContactForm from "@/components/contact/ContactForm.vue";
import Page from "@/components/Page.vue";
import store from "@/store/store";

const user = computed(() => store.state.auth.user);
</script>

<template>
  <Page :title="$t('contact_form.contact_support')" :with-back-button="true">
    <div class="contact-page-content">
      <div class="desktop-layout">
        <div class="image-section">
          <img 
            class="contact-illustration" 
            src="/src/assets/images/contact.png" 
            alt="Contact Support Illustration" 
          />
        </div>
        
        <div class="form-section">
          <ContactForm
            :name="!user.isTemporary ? user.name : ''"
            :email="!user.isTemporary ? user.email : ''"
            :with-title="false"
            class="contact-form"
          />
        </div>
      </div>
    </div>
  </Page>
</template>

<style scoped lang="scss">
.contact-page-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
}

.desktop-layout {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  align-items: center;
  min-height: 60vh;
}

.image-section {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
}

.contact-illustration {
  width: 100%;
  height: auto;
  max-width: 450px;
  border-radius: 16px;
  opacity: 0.9;
}

.form-section {
  width: 100%;
  display: flex;
  justify-content: center;
}

.contact-form {
  width: 100%;
  max-width: 500px;
}

// Clean styling for the form
:deep(.contact-form-container) {
  background-color: transparent;
  border: none;
  box-shadow: none;
  max-height: none;
  width: 100%;
}

:deep(.contact-form) {
  padding: 0;
  width: 100%;
}

:deep(.form-content) {
  margin-top: 0;
  width: 100%;
}

:deep(.form-field) {
  margin-bottom: 24px;
  width: 100%;
}

:deep(.form-input) {
  width: 100%;
  padding: 18px 20px;
  font-size: 16px;
}

:deep(.form-textarea) {
  min-height: 120px;
  padding: 18px 20px;
}

:deep(.submit-btn) {
  width: 100%;
  max-width: none;
  padding: 18px 20px;
  font-size: 17px;
  margin-bottom: 0;
}

// Hide image on tablets and mobile
@media (max-width: 968px) {
  .contact-page-content {
    max-width: none;
    margin: 0 -30px;
    padding: 40px 30px;
    width: calc(100% + 60px);
  }

  .desktop-layout {
    grid-template-columns: 1fr;
    gap: 0;
    min-height: auto;
  }

  .image-section {
    display: none;
  }

  .form-section {
    justify-content: stretch;
    width: 100%;
  }

  .contact-form {
    max-width: none !important;
    width: 100%;
  }

  // Override the hardcoded max-width in ContactForm component
  :deep(.contact-form-container) {
    width: 100% !important;
    max-width: none !important;
    margin: 0;
  }

  :deep(.contact-form) {
    width: 100%;
  }
}

@media (max-width: 768px) {
  .contact-page-content {
    margin: 0 -30px;
    padding: 20px 20px;
    width: calc(100% + 60px);
    max-width: none;
  }

  :deep(.form-input),
  :deep(.form-textarea) {
    padding: 16px 18px;
    font-size: 16px;
  }

  :deep(.submit-btn) {
    padding: 16px 18px;
    font-size: 16px;
  }
}
</style>
